// extracted by mini-css-extract-plugin
export default {"root":"_1zNn1","warning":"d-yz7"};